import React from 'react';
import PropTypes from 'prop-types';
import {formatMoney} from '@shopify/theme-currency';
import {getSizedImageUrl} from '@shopify/theme-images';
import Flickity from 'react-flickity-component';

/* eslint-disable babel/camelcase */
const CartUpsells = ({total, products, addToCart}) => {
  const flickityOptions = {
    freeScroll: false,
    prevNextButtons: false,
    pageDots: true,
    imagesLoaded: true,
    setGallerySize: true,
    cellAlign: 'left',
    watchCSS: false,
    adaptiveHeight: false,
    contain: true,
  };

  const upsellsTitle = window.theme.upsells.title || 'You may also like';

  return (
    <>
      {total > 0 && products.length > 0 && (
        <div className="cart-upsells">
          <div className="bar" />
          <h5>{upsellsTitle}</h5>
          <Flickity
            className="cart__upsells--slider"
            elementType="div"
            options={flickityOptions}
            disableImagesLoaded={false}
            reloadOnUpdate
            static
          >
            {products.map(({variants, title, featured_image, id, handle}) => {
              const availableNonFreeVariant = variants.find((variant) => variant.available && variant.price > 0);
              return (
                <div key={id} className="cart__upsells-slide">
                  <div className="cart__upsells-slide--wrapper">
                    {featured_image && (
                      <a href={`/products/${handle}`} className="cart__upsell-image--wrapper">
                        <div className="cart__upsell-image">
                          <img src={getSizedImageUrl(featured_image, '128x160_crop_center')} alt={title} />
                        </div>
                      </a>
                    )}
                    <div className="cart__upsell-info">
                      <p className="cart__upsell-title h5">{title}</p>
                      {availableNonFreeVariant && (
                        <>
                          <span
                            className="cart__upsell-price"
                            dangerouslySetInnerHTML={{
                              __html: `${formatMoney(availableNonFreeVariant.price, window.theme.moneyFormat)} ${
                                window.Shopify.currency.active
                              }`,
                            }}
                          />
                          <div class="cart__upsell-cta-wrap">
                            <button
                              type="button"
                              className="btn btn--text btn--text-underline"
                              data-upsell-handle={handle}
                              onClick={() => addToCart('addToCart', availableNonFreeVariant.id, 1)}
                            >
                              Add To Bag
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </Flickity>
        </div>
      )}
    </>
  );
};
/* eslint-enable babel/camelcase */

/* eslint-disable react/forbid-prop-types */
CartUpsells.propTypes = {
  total: PropTypes.number,
  products: PropTypes.array,
  addToCart: PropTypes.func,
};
/* eslint-enable react/forbid-prop-types */

export default CartUpsells;
